import { request } from '@/utils/request/request';

export function getDataDictionary(data) {
  return request({
    url: 'api/APP/v1/GetItemsDataDetail',
    method: 'GET',
    params: data,
  });
}

export function getbianyaqisunhaofenxi() {
  return request({});
}
